import { useEffect, useState } from "react";
import { CheckCircle2, X } from "lucide-react";
import IsoDateInput from "../common/Isodateinput";

export const ApproveLoanDialog = ({
  open,
  loan,
  loading,
  onClose,
  onConfirm,
}) => {
  const [processedDate, setProcessedDate] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setProcessedDate("");
      setError("");
    }
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (!processedDate) {
      setError("Processed date is required.");
      return;
    }
    onConfirm(processedDate);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-xs transition-opacity"
        onClick={!loading ? onClose : undefined}
      />

      {/* Modal Card */}
      <div className="relative z-10 w-full max-w-sm rounded-xl bg-white p-5 shadow-lg">
        {/* Header: Icon + Title + Close Button */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
              <CheckCircle2 size={17} strokeWidth={2} />
            </div>
            <h2 className="text-[14px] font-semibold text-gray-900">
              Approve Loan
            </h2>
          </div>

          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
          >
            <X size={16} />
          </button>
        </div>

        {/* Full-width Body */}
        <div className="mt-3">
          <p className="text-[13px] leading-5 text-gray-500">
            Enter the processed date to approve loan{" "}
            <span className="font-semibold text-gray-700">{loan?.loanNo}</span>.
          </p>

          <div className="mt-3.5">
            <label className="mb-1 block text-[12px] font-medium text-gray-700">
              Processed Date <span className="text-red-500">*</span>
            </label>
            <IsoDateInput
              value={processedDate}
              onChange={(e) => {
                const val = e?.target ? e.target.value : e;
                setProcessedDate(val);
                if (val) setError("");
              }}
              className={`h-9 w-full rounded-lg border bg-white px-3 text-[13px] text-gray-900 outline-none transition-colors ${
                error
                  ? "border-red-400 focus:border-red-500 focus:ring-1 focus:ring-red-500"
                  : "border-gray-200 focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
              }`}
            />
            {error && <p className="mt-1 text-[11px] text-red-600">{error}</p>}
          </div>
        </div>

        {/* Actions */}
        <div className="mt-5 flex items-center justify-end gap-1 border-t border-gray-100 pt-3">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="h-8 rounded-lg px-3 text-[12px] font-semibold text-gray-500 hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            type="button"
            disabled={loading || !processedDate}
            onClick={handleConfirm}
            className="h-8 rounded-lg bg-primary-600 px-3.5 text-[12px] font-semibold text-white transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:bg-primary-400"
          >
            {loading ? "Approving..." : "Approve"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveLoanDialog;